<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-table [tableColumns]="benefitSummariesColumns" [dataSource]="benefitSummariesMatTableData" (emitButtonSelection)="downloadBenefitSummary($event)" (emitButtonSelection2)="openEmailDialog($event)" header="Benefit Summary Files" />
    </div>
</div>